import { isNonProductionEnv } from './isProductionEnv';

const LOCALHOST_IPS = new Set(['127.0.0.1', '::1']);

let cachedPersonalIps: Set<string> | undefined;

function parsePersonalIps(value: string | undefined): Set<string> {
  if (!value?.trim()) return new Set();

  return new Set(
    value
      .split(',')
      .map((ip) => ip.trim())
      .filter(Boolean),
  );
}

export function getPersonalIps(): Set<string> {
  if (cachedPersonalIps) return cachedPersonalIps;
  cachedPersonalIps = parsePersonalIps(process.env.EXP_PERSONAL_IPS);
  return cachedPersonalIps;
}

export function resetPersonalIpsCache(): void {
  cachedPersonalIps = undefined;
}

export function isPersonalIp(clientIp: string | undefined): boolean {
  if (!clientIp) return false;
  if (isNonProductionEnv() && LOCALHOST_IPS.has(clientIp)) return true;
  return getPersonalIps().has(clientIp);
}
